var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"Número do Terminal"},model:{value:(_vm.terminalNumber),callback:function ($$v) {_vm.terminalNumber=$$v},expression:"terminalNumber"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }